(function () {
  if (window.IdealMobileSectionRailLoaded) return;
  window.IdealMobileSectionRailLoaded = true;

  var rails = [];
  var media = window.matchMedia('(max-width: 768px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getRailSettings(rail) {
    var prefix = media.matches ? 'mobile' : 'desktop';
    var mode = rail.dataset[prefix + 'Mode'] || rail.dataset.mobileMode || 'normal';

    return {
      mode: mode,
      interval: rail.dataset[prefix + 'Interval'] || rail.dataset.mobileInterval || '3',
      tickerSpeed: rail.dataset[prefix + 'TickerSpeed'] || rail.dataset.mobileTickerSpeed || '30'
    };
  }

  function clearRail(rail) {
    if (rail._mobileRailTimer) {
      window.clearInterval(rail._mobileRailTimer);
      rail._mobileRailTimer = null;
    }

    if (rail._mobileRailFrame) {
      window.cancelAnimationFrame(rail._mobileRailFrame);
      rail._mobileRailFrame = null;
    }

    if (rail._mobileRailClones) {
      rail._mobileRailClones.forEach(function (clone) {
        clone.remove();
      });
      rail._mobileRailClones = null;
    }
  }

  function getDropdownLabel(rail) {
    if (rail.dataset.mobileDropdownLabel) {
      return rail.dataset.mobileDropdownLabel;
    }

    var section = rail.closest('section');
    var heading = section && section.querySelector('h2, h3');
    if (heading && heading.textContent.trim()) {
      return heading.textContent.trim();
    }

    return 'View details';
  }

  function ensureDropdown(rail) {
    var section = rail.closest('section');
    if (!rail.id) {
      rail.id = 'mobile-rail-' + Math.random().toString(36).slice(2);
    }

    if (!rail._mobileRailDropdownButton) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'mobile-rail-dropdown-toggle';
      button.setAttribute('aria-controls', rail.id);
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', function () {
        var isOpen = rail.classList.toggle('is-open');
        if (section) {
          section.classList.toggle('mobile-rail-dropdown-section--open', isOpen);
        }
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
      rail.parentNode.insertBefore(button, rail);
      rail._mobileRailDropdownButton = button;
    }

    rail._mobileRailDropdownButton.textContent = getDropdownLabel(rail);
    rail.classList.add('mobile-rail--dropdown');
    rail.classList.remove('is-open');
    if (section) {
      section.classList.add('mobile-rail-dropdown-section');
      section.classList.remove('mobile-rail-dropdown-section--open');
    }
    rail._mobileRailDropdownButton.setAttribute('aria-expanded', 'false');
  }

  function clearDropdown(rail) {
    var section = rail.closest('section');
    rail.classList.remove('mobile-rail--dropdown', 'is-open');
    if (section) {
      section.classList.remove('mobile-rail-dropdown-section', 'mobile-rail-dropdown-section--open');
    }
    if (rail._mobileRailDropdownButton) {
      rail._mobileRailDropdownButton.remove();
      rail._mobileRailDropdownButton = null;
    }
  }

  function getItems(rail) {
    return Array.prototype.slice.call(rail.querySelectorAll(':scope > .mobile-rail__item:not([data-mobile-rail-clone])'));
  }

  function scrollToNext(rail) {
    var items = getItems(rail);
    if (items.length < 2) return;

    var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
    var isAtEnd = rail.scrollLeft >= maxScroll - 2;
    if (isAtEnd) {
      rail.scrollTo({
        left: 0,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
      return;
    }

    var current = 0;
    var railLeft = rail.getBoundingClientRect().left;

    items.forEach(function (item, index) {
      if (item.getBoundingClientRect().left - railLeft < rail.clientWidth * 0.4) {
        current = index;
      }
    });

    var next = items[current + 1];
    var nextLeft = next ? Math.min(next.offsetLeft - rail.offsetLeft, maxScroll) : 0;
    rail.scrollTo({
      left: nextLeft,
      behavior: reduceMotion.matches ? 'auto' : 'smooth'
    });
  }

  function startTimedCarousel(rail, settings) {
    var seconds = parseFloat(settings.interval || '3');
    if (!seconds || seconds < 1) seconds = 1;
    rail._mobileRailTimer = window.setInterval(function () {
      var activeSettings = getRailSettings(rail);
      if (document.hidden || activeSettings.mode !== 'timed' || reduceMotion.matches) return;
      scrollToNext(rail);
    }, seconds * 1000);
  }

  function startTicker(rail, settings) {
    var originals = getItems(rail);
    if (originals.length < 2 || reduceMotion.matches) return;

    rail._mobileRailClones = originals.map(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('data-mobile-rail-clone', 'true');
      clone.setAttribute('aria-hidden', 'true');
      rail.appendChild(clone);
      return clone;
    });

    var speed = parseFloat(settings.tickerSpeed || '30');
    if (!speed || speed < 5) speed = 5;

    var lastTime = null;

    function tick(time) {
      var activeSettings = getRailSettings(rail);
      if (activeSettings.mode !== 'ticker') {
        clearRail(rail);
        return;
      }

      if (lastTime === null) lastTime = time;
      var delta = (time - lastTime) / 1000;
      lastTime = time;

      if (!document.hidden) {
        rail.scrollLeft += speed * delta;
        if (rail.scrollLeft >= rail.scrollWidth / 2) {
          rail.scrollLeft = 0;
        }
      }

      rail._mobileRailFrame = window.requestAnimationFrame(tick);
    }

    rail._mobileRailFrame = window.requestAnimationFrame(tick);
  }

  function setupRail(rail) {
    clearRail(rail);
    clearDropdown(rail);

    var settings = getRailSettings(rail);
    rail.dataset.currentRailMode = settings.mode;

    if (settings.mode === 'normal') return;

    if (settings.mode === 'dropdown') {
      if (media.matches) {
        ensureDropdown(rail);
      } else {
        rail.dataset.currentRailMode = 'normal';
      }
    } else if (settings.mode === 'timed') {
      startTimedCarousel(rail, settings);
    } else if (settings.mode === 'ticker') {
      startTicker(rail, settings);
    }
  }

  function setupAll() {
    rails = Array.prototype.slice.call(document.querySelectorAll('[data-mobile-rail]'));
    rails.forEach(setupRail);
  }

  window.IdealMobileSectionRailRefresh = setupAll;

  document.addEventListener('DOMContentLoaded', setupAll);
  document.addEventListener('shopify:section:load', setupAll);
  media.addEventListener('change', setupAll);
  reduceMotion.addEventListener('change', setupAll);
})();
